export default __webpack_public_path__ + "static/media/drop-2-black.b1834f0c.jpg";